// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* --green: rgb(35,82,96); */
  --green: #1C234C;
  --shadow: 0 0 2px rgba(0, 0, 0, 0.05);
  --radius:6px;
}
body {
  background-color: #f3f2f7;
  scroll-behavior: smooth;
  overflow-x: hidden;
  width: 100vw;
}
#wrapper {
  height: 100%;
}
#cover {
}
.cover {
  /* background-color: black; */
  background-color: #1C234C;
  height: 100px;
  position: relative;
  display: flex;
  justify-content: center;
}
.profile {
  width: 70px;
  height: 70px;
  position: absolute;
  /* background: var(--green); */
  background: #1C234C;
  bottom: -35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 30px;
  border: 2px solid white;
  color: white;
}

#personalInfo {
  margin-top: 50px;
}
#personalInfo div {
  text-align: center;
}
#personalInfo div:nth-of-type(1) {
  font-size: 32px;
  font-weight: bold;
}
#personalInfo div:nth-of-type(2) {
  /* color: var(--green); */
  color: #1C234C;
  font-size: 14px;
  margin-top: 10px;
}
#personalInfo div:nth-of-type(3) {
  font-size: 12px;
}
#personalInfo div:nth-of-type(4) {
  font-size: 12px;
  margin-top: 15px;
  padding: 0px 20px;
  opacity: 0.5;
}
#functions {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;
  gap: 20px;
}
.button {
  width: 100%;
  height: 70px;
  border: 1px solid #efefef;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  /* color: var(--green); */
  color: #1C234C;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 5px 0px;
  font-size: 14px;
  cursor: pointer;
}
.button.active {
  /* background-color: var(--green); */
  background-color: #1C234C;
  color: #fff;
}
.button.active svg {
  fill: white;
}

#contact {
  background-color: white;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  margin: 10px;
  margin-top: 30px;
}
.contactItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 5px;
  border-top: 1px solid rgb(225, 225, 225);
  align-items: center;
}
.contactItemKey {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.contactItemValue{margin-right: 10px;}
.contactItem img {
  width: 16px;
  height: 16px;
  opacity: 0.74;
  margin: 0 10px;
}
.contactItem:nth-child(1) {
  border-top: none;
}
#social {
  margin: 30px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;
  gap: 20px;
}

.saveButton{
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: var(--green); */
  background-color: #1C234C;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  color: #fff;
  padding: 20px;
  font-size: 20px;
  margin: 10px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;AACA;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA,kBAAkB,kBAAkB,CAAC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;AACjB","sourcesContent":[":root {\n  /* --green: rgb(35,82,96); */\n  --green: #1C234C;\n  --shadow: 0 0 2px rgba(0, 0, 0, 0.05);\n  --radius:6px;\n}\nbody {\n  background-color: #f3f2f7;\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n  width: 100vw;\n}\n#wrapper {\n  height: 100%;\n}\n#cover {\n}\n.cover {\n  /* background-color: black; */\n  background-color: #1C234C;\n  height: 100px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.profile {\n  width: 70px;\n  height: 70px;\n  position: absolute;\n  /* background: var(--green); */\n  background: #1C234C;\n  bottom: -35px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 30px;\n  border: 2px solid white;\n  color: white;\n}\n\n#personalInfo {\n  margin-top: 50px;\n}\n#personalInfo div {\n  text-align: center;\n}\n#personalInfo div:nth-of-type(1) {\n  font-size: 32px;\n  font-weight: bold;\n}\n#personalInfo div:nth-of-type(2) {\n  /* color: var(--green); */\n  color: #1C234C;\n  font-size: 14px;\n  margin-top: 10px;\n}\n#personalInfo div:nth-of-type(3) {\n  font-size: 12px;\n}\n#personalInfo div:nth-of-type(4) {\n  font-size: 12px;\n  margin-top: 15px;\n  padding: 0px 20px;\n  opacity: 0.5;\n}\n#functions {\n  margin-top: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0px 10px;\n  gap: 20px;\n}\n.button {\n  width: 100%;\n  height: 70px;\n  border: 1px solid #efefef;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 5px;\n  /* color: var(--green); */\n  color: #1C234C;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 5px 0px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.button.active {\n  /* background-color: var(--green); */\n  background-color: #1C234C;\n  color: #fff;\n}\n.button.active svg {\n  fill: white;\n}\n\n#contact {\n  background-color: white;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  margin: 10px;\n  margin-top: 30px;\n}\n.contactItem {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 10px 5px;\n  border-top: 1px solid rgb(225, 225, 225);\n  align-items: center;\n}\n.contactItemKey {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}\n.contactItemValue{margin-right: 10px;}\n.contactItem img {\n  width: 16px;\n  height: 16px;\n  opacity: 0.74;\n  margin: 0 10px;\n}\n.contactItem:nth-child(1) {\n  border-top: none;\n}\n#social {\n  margin: 30px 0px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0px 10px;\n  gap: 20px;\n}\n\n.saveButton{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* background-color: var(--green); */\n  background-color: #1C234C;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  color: #fff;\n  padding: 20px;\n  font-size: 20px;\n  margin: 10px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
